import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppNotification } from '@/feature/utils';

import { CommitteeForm } from './CommitteeForm';
import { useCommitteeEdit } from './model/CommitteeQuery';
import { CommitteeSchema, committeeSchema, defaultCommitteeValues } from './model/CommitteeSchema';
import { Committee } from './model/CommitteeTypes';

interface CommitteeEditProps {
  committee: Committee;
}

const convert = (committee: Committee): CommitteeSchema => ({
  ...committee,
});

export function CommitteeEdit(props: CommitteeEditProps) {
  const { committee } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useCommitteeEdit(committee.id);
  const notification = useAppNotification();

  const onSubmit = (values: CommitteeSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(committee), [committee]);
  const navigate = useNavigate();

  return (
    <CommitteeForm
      title={t('committees.form.title.edit')}
      schema={committeeSchema}
      defaultValues={defaultCommitteeValues}
      values={values}
      onSubmit={onSubmit}
      isError={isError}
      isSuccess={isSuccess}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
